// extracted by mini-css-extract-plugin
export default {"iconContainer":"errorPage_iconContainer__hRdHt","fullView":"errorPage_fullView__fEHRJ","shimmer":"errorPage_shimmer__cHHg7"};